// @flow
/** @jsx jsx */

import _ from 'lodash';

import { jsx } from '@emotion/core';

const imageCss = (isSmall: boolean) => ({
  display: 'inline-block',
  width: isSmall ? 50 : 60,
});

const svgCss = props => ({
  display: 'block',
  height: 'inherit',
  opacity: props.isDisabled ? 0.4 : 1.0,
  width: 'inherit',
});

type Props = {
  /** Image type to show */
  imageType: string,
  /** Show image greyed out */
  isDisabled?: boolean,
  /** Show small version of image */
  isSmall?: boolean,
};

const PaymentMethodImage = (props: Props) => {
  const { imageType, isSmall = false } = props;
  let ImageSvg;
  try {
    ImageSvg = require(`./images/${_.kebabCase(imageType)}.svg`).default;
  } catch (e) {
    // $FlowFixMe - flow doesn't understand the require not sure why it doesn't complain about the one above
    ImageSvg = require('./images/unknown.svg').default;
  }
  return (
    <span css={imageCss(isSmall)}>
      <ImageSvg css={svgCss(props)} />
    </span>
  );
};

export default PaymentMethodImage;
